import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { api } from "@/lib/api";

const DISMISS_KEY = "kc_banner_dismissed";

export const SeasonalBanner = () => {
  const [banner, setBanner] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/settings/banner").then((r) => {
      const b = r.data;
      if (b?.ends_at && new Date() > new Date(b.ends_at)) return;
      if (b?.starts_at && new Date() < new Date(b.starts_at)) return;
      if (b?.enabled && b?.title) {
        setBanner(b);
        const dismissed = sessionStorage.getItem(DISMISS_KEY);
        if (dismissed === b.title) setHidden(true);
      }
    }).catch(() => {});
  }, []);

  if (!banner || hidden) return null;

  const dismiss = () => { sessionStorage.setItem(DISMISS_KEY, banner.title); setHidden(true); };

  return (
    <div
      data-testid="seasonal-banner"
      className="relative w-full"
      style={{ backgroundColor: banner.bg || "#B84A3B", color: banner.fg || "#FFFFFF" }}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-2.5 flex items-center justify-center gap-4 text-center flex-wrap">
        <span className="font-display text-base sm:text-lg tracking-tight" data-testid="banner-title">{banner.title}</span>
        {banner.subtitle && <span className="hidden sm:inline text-sm opacity-85 font-body">{banner.subtitle}</span>}
        {banner.cta_link && banner.cta_text && (
          banner.cta_link.startsWith("http") ? (
            <a
              href={banner.cta_link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="banner-cta"
              className="inline-flex items-center gap-1.5 text-[0.66rem] font-mono tracking-[0.16em] uppercase px-3 py-1.5 hover:opacity-80 transition-opacity"
              style={{ backgroundColor: banner.fg || "#FFFFFF", color: banner.bg || "#B84A3B" }}
            >
              {banner.cta_text} <ArrowRight size={12} />
            </a>
          ) : (
            <Link
              to={banner.cta_link}
              data-testid="banner-cta"
              className="inline-flex items-center gap-1.5 text-[0.66rem] font-mono tracking-[0.16em] uppercase border-b pb-0.5 hover:opacity-80 transition-opacity"
              style={{ borderColor: banner.fg || "#FFFFFF" }}
            >
              {banner.cta_text} <ArrowRight size={12} />
            </Link>
          )
        )}
      </div>
      <button
        onClick={dismiss}
        data-testid="banner-dismiss"
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition-opacity"
      >
        <X size={16} />
      </button>
    </div>
  );
};
